module.exports = __webpack_public_path__ + "static/P2101483-3c67adceaa096e1faaa42e7de81f0af3.jpg";